import { render, staticRenderFns } from "./CrumbNav.vue?vue&type=template&id=1c0f06ea&scoped=true"
import script from "./CrumbNav.vue?vue&type=script&lang=js"
export * from "./CrumbNav.vue?vue&type=script&lang=js"
import style0 from "./CrumbNav.vue?vue&type=style&index=0&id=1c0f06ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f06ea",
  null
  
)

export default component.exports